import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Updates device and (when Port Type exists) cable images on variant:update.
 *
 * @typedef {Object} Refs
 * @property {HTMLImageElement} [deviceImage]
 * @property {HTMLImageElement} [cableImage]
 *
 * @extends {Component<Refs>}
 */
class ProductWhatsInTheBoxComponent extends Component {
  requiredRefs = undefined;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail?.data?.newProduct) {
      this.dataset.productId = String(event.detail.data.newProduct.id);
    }

    const eventProductId = String(event.detail?.data?.productId ?? '');
    const myId = String(this.dataset.productId ?? '');
    if (eventProductId && eventProductId !== myId) {
      return;
    }

    const resource = event.detail?.resource;
    if (!resource) return;

    const img = /** @type {HTMLImageElement | undefined} */ (this.refs.deviceImage);
    if (img) {
      const previewSrc = resource.featured_media?.preview_image?.src;
      const featuredSrc = resource.featured_image?.src;
      const src = previewSrc || featuredSrc || this.dataset.fallbackDeviceSrc || '';

      if (src) {
        img.src = src;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      }
    }

    const cableImg = /** @type {HTMLImageElement | undefined} */ (this.refs.cableImage);
    if (!cableImg) return;

    const pos = parseInt(this.dataset.portTypePosition || '0', 10);
    if (pos < 1 || pos > 3) return;

    const key = pos === 1 ? 'option1' : pos === 2 ? 'option2' : 'option3';
    const raw = resource[key];
    const val = typeof raw === 'string' ? raw.trim().toLowerCase() : '';

    let url = '';
    if (val === 'type-c' || val === 'type c') {
      url = this.dataset.fallbackCableUrl || '';
    } else if (val === 'lightning') {
      url = this.dataset.genericCableUrl || this.dataset.fallbackCableUrl || '';
    } else {
      url = this.dataset.genericCableUrl || this.dataset.fallbackCableUrl || '';
    }

    if (url) {
      cableImg.src = url;
      cableImg.removeAttribute('srcset');
      cableImg.removeAttribute('sizes');
    }
  };
}

if (!customElements.get('product-whats-in-the-box')) {
  customElements.define('product-whats-in-the-box', ProductWhatsInTheBoxComponent);
}
